<form>
    <div class="mb-3 w-100 d-table col-12">
        <span class="float-start col-12">
            <label for="signatureMethod" class="form-label"
                translate="Settings.AccountSignatureSection.Method"><app-info-button
                    labelName="Settings.AccountSignatureSection.MethodTooltip"></app-info-button></label>
            <div ngbDropdown class="dropdown" ngDefaultControl name="signatureMethod" id="signatureMethod">
                <button class="btn btn-sm language dropdown-toggle form-control text-truncate default" type="button"
                    id="dropdownMenu" ngbDropdownToggle>
                    {{ "Settings.AccountSignatureSection." + ((signatureProviderClaim === "Advanced" ||
                    signatureProviderClaim === null) ? "Eseal" : signatureProviderClaim) | translate }}
                    <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownMenu">
                    <button ngbDropdownItem value="Advanced" (click)="changeSignMethod('Advanced')"
                        translate="Settings.AccountSignatureSection.Eseal"></button>
                    <button ngbDropdownItem value="Token" (click)="changeSignMethod('Token')"
                        translate="Settings.AccountSignatureSection.Token"></button>
                    <button ngbDropdownItem value="HardTokenAgentSignatureProvider"
                        (click)="changeSignMethod('HardTokenAgentSignatureProvider')"
                        translate="Settings.AccountSignatureSection.HardTokenAgentSignatureProvider"></button>
                    <button ngbDropdownItem value="CscSignatureProvider"
                        (click)="changeSignMethod('CscSignatureProvider')"
                        translate="Settings.AccountSignatureSection.CscSignatureProvider"></button>
                </div>
            </div>
        </span>
    </div>
    <div class="w-100 d-table col-12">
        <label for="defaultTrustServiceProvider" class="form-label"
            translate="Settings.AccountSignatureSection.DefaultTrustServiceProvider"></label>
        <div ngbDropdown class="dropdown" ngDefaultControl name="defaultTrustServiceProvider"
            id="defaultTrustServiceProvider">
            <button class="btn btn-sm language dropdown-toggle form-control text-truncate default"
                [ngClass]="{'btn-dropdown-disabled': signatureProviderClaim !== 'CscSignatureProvider'}" type="button"
                id="dropdownMenu" [disabled]="signatureProviderClaim !== 'CscSignatureProvider'" ngbDropdownToggle>
                {{ cloudProvider ? cloudProvider?.name : 'Settings.AccountSignatureSection.Choose' | translate}}
                <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownMenu">
                <ng-container *ngFor="let provider of signatureProviders; let i = index;">
                    <button ngbDropdownItem [value]="provider" (click)="changeCloudProvider(provider.code)">
                        {{provider.name}}
                    </button>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="col-12 py-3">
        <button type="button" id="buttonSave" class="btn btn-sm btn-primary float-end" (click)="saveSignatureMethod();"
            translate="Button.SaveChanges"></button>
    </div>
</form>